import { render } from "./SideAccountVars.vue?vue&type=template&id=5e6011da&ts=true"
import script from "./SideAccountVars.vue?vue&type=script&lang=ts"
export * from "./SideAccountVars.vue?vue&type=script&lang=ts"

import "./SideAccountVars.vue?vue&type=style&index=0&id=5e6011da&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__